import { api } from './api';
import { searchGetCourseMeta } from './helpers';
import { getTenant } from '../helpers';

export function
getUserCoursesAPI(username: string): Promise<any[]> {
  return new Promise<any[]>((resolve, reject) => {
    const tenant = getTenant();

    // Function to fetch courses for a specific tenant
    const fetchCourses = (tenantKey: string) => {
      return new Promise<any[]>((resolve, reject) => {
        const requestData = {
          username: username,
          platform_key: tenantKey
        };

        api.ibldmcourses.getUserCourses(requestData, (response) => {
          if ( response?.results && Array.isArray(response?.results)){
            resolve(response?.results);

          } else {
            resolve([])
          }
        });
      });
    };

    if (tenant === 'main') {
      // If the tenant is "main", only fetch courses for "main"
      fetchCourses(tenant).then(courses => resolve(courses)).catch(error => reject(error));
    } else {
      // If the tenant is not "main", fetch courses for both the current tenant and "main"
      Promise.all([
        fetchCourses(tenant),
        fetchCourses('main')
      ]).then(results => {
        // Aggregate results from both tenants
        const aggregatedCourses = [].concat(...results);
        resolve(aggregatedCourses);
      }).catch(error => reject(error));
    }
  });
}


export function getUserCoursesMetaData(course_id) {
  return new Promise((resolve) => {
    api.ibledxcourses.getCourseMeta({ course_key: course_id }, function (data) {
      resolve(data);
    });
  });
}

export function getUserCoursesSearchData(course_id) {
  return new Promise((resolve) => {
    searchGetCourseMeta(course_id, (metaData) => {
      if (
        metaData &&
        !metaData.message &&
        metaData.results &&
        Array.isArray(metaData.results) &&
        metaData.results.length > 0
      ) {
        resolve(metaData.results[0]);
      } else {
        resolve(null);
      }
    });
  });
}
